import { Component } from '@angular/core';
@Component({
    templateUrl: './unsubscribe-success.component.html'
})
export class UnsubscribeSucessComponent {
}


// WEBPACK FOOTER //
// ./src/app/clients/auth/unsubscribe/unsubscribe-success.component.ts